import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let updatePaymentStatusMachine: any;

export const useSMupdatePaymentStatus = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updatePaymentStatusMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updatePaymentStatusMachine);

  return {
    updatePaymentStatusMachine,
    updatePaymentStatusState: state,
    updatePaymentStatusSend: send,
  };
};
